// External event aggregation is intentionally disabled while CivixThread
// focuses on events hosted directly on the platform. Set the build-time
// environment variable to "true" when the integration is ready to return.
export const MOBILIZE_EVENTS_ENABLED =
  process.env.REACT_APP_ENABLE_MOBILIZE_EVENTS === "true";
